<template>
  <!-- 评论回复栏 -->
  <div class="comment_unfold unfold">
    <div class="comment_unfold_box">
      <!-- 回复内容部分 -->
      <div>
        <span class="user_name blur" v-if="commentChild.level != 3">
          {{
            commentChild.from_user_name == ""
              ? "班主任"
              : commentChild.from_user_name
          }}</span
        >
        <span class="user_name blur" v-else>
          <!-- 针对后台回复的情况用户名称为空这里做一次判断，如果用户名为空字符串则使用自定义的名称 -->
          {{
            commentChild.from_user_name == ""
              ? "班主任"
              : commentChild.from_user_name
          }}
          <span class="comment_content">回复</span>
          {{ commentChild.to_user_name }}
        </span>
        <span> : </span>
        <span class="comment_content">
          {{ commentChild.content }}
        </span>
      </div>
      <!-- 时间以及点赞评论部分 -->
      <div class="comment_info comment_info_child">
        <commentInfo
          :info="commentChild"
          :share_id="share_id"
          @addcomment="infoAdd($event)"
          :num="num"
        ></commentInfo>
      </div>
    </div>
  </div>
</template>

<script>
import commentInfo from "./commentInfo.vue";
export default {
  name: "commentUnflod",
  components: {
    commentInfo,
  },
  props: {
    // 楼层
    num: {
      type: Number,
      default: null,
    },
    commentChild: {
      type: Object,
      default: () => {
        return {
          content: "二级评论333",
          from_user_name: "152****3560",
          is_praised: 0,
          level: 2,
          praised_count: 0,
          reamrk_id: 5,
          to_user_name: "测试",
        };
      },
    },
    share_id: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      // 往commentInfo里面传的值
      commentInfo: {},
    };
  },
  methods: {
    infoAdd(event) {
      this.$emit("Addcomment", event);
    },
  },
  watch: {
    commentChild(newValue) {
      let { from_user_name, praised_count } = newValue;
      this.commentInfo = {
        from_user_name,
        praised_count,
        time: "1999.99.99（缺少时间）",
      };
    },
  },
};
</script>

<style lang="less" scoped>
// 评论展开部分
.comment_content {
  color: #585a58;
}
.unfold {
  padding-left: 0.75rem;
  width: 100%;
  height: 2.0625rem;
  background: #f6f6f6;
  line-height: 2.0625rem;
}
// 评论回复栏
.comment_unfold {
  padding: 0.5625rem 0.6875rem 0.0625rem 0.75rem;
  height: auto;
  line-height: normal;

  .comment_unfold_box {
    border-bottom: 0.0625rem solid #d9d9d9;
  }
}
</style>